import {UUID_KEY} from "@/constants/localStorageKeys";
import { v4 as uuidv4 } from 'uuid';

export const useUuidStore = () => {
  return {
    get uuid() {
      return localStorage.getItem(UUID_KEY)
    },
    setUuidIfNotExists() {
      if (this.uuid === null) {
        localStorage.setItem(UUID_KEY, uuidv4());
      }
    }
  }
}
